<header class="account__setup--header">
  <span class="app__form--attribute--title font-semibold text-base"> Network Set Up</span>
  <button matTooltipPosition="above" data-dismiss="modal" class="bg-white" (click)="closeSideNav()">
    <span class="material-icons relative bg-white">clear</span>
  </button>
</header>

<section class="flex" [style]="screenWidth > 480 ? 'height: 90vh' : 'margin-bottom: 60px'">
  @if (screenWidth > 480) {
  <div class="nav w-[253px]">
    <nav class="w-full">
      <ul class="w-full pt-5">
        @for (step of steps; track step; let index = $index; let last = $last) {
        <li
          class="app__stepper__config-stepitem"
          [class]="step.completed ? 'hover:text-[#1AA140] cursor-default' : ''"
          [ngClass]="{
            'app__stepper__config-stepitem-completed': step.completed,
            'app__stepper__config-stepitem-notcompleted': !step.completed,
            'app__stepper__config-stepitem-selected  app__network--setup-selected': step.status == 'active',
            hidden: index == 0 && switchFromUser
          }"
          (click)="handleSidenavMenuNavigation(index)"
        >
          @if (step.completed) {
          <img class="app__stepper__image-checked" src="../../../../assets/images/check-green.svg" alt="green-check" />
          }
          {{ step.title | titlecase }}
        </li>
        }
      </ul>
    </nav>
  </div>
  }

  <div
    class="pr-0"
    [ngClass]="{
      'account__setup--body ': !isImpersonating,
      'account__setup-impersonating-body': isImpersonating,
    }"
  >
    <!-- Set Up Two Factor Authentication -->
    <div
      [ngClass]="{
        'h-full flex flex-col justify-between': true
      }"
    >
      <div class="h-[85.5%] max-h-[85.5%] overflow-y-auto">
        @if(currentActiveIndex === 0){
        <instruction-setup
          style="margin-right: 42px; display: block"
          [setupInstructions]="setupInstructions"
          [title]="'Network Set Up'"
          [videoSrc]="videoSrc"
        ></instruction-setup>
        } @else if(currentActiveIndex >= 1 && currentActiveIndex<= steps.length - 2 ){ @for(setup of steps; track $index){ @if(currentActiveIndex ===
        $index ){

        <setup-controller
          style="padding-right: 42px; display: block; height: 100%"
          [currentUser]="currentUser"
          [screenWidth]="screenWidth"
          (optionValueEmitter)="handleOptionValueEmitter($event)"
          [text]="handleSetupText(steps[currentActiveIndex].title)"
          [subText]="steps[currentActiveIndex].subText"
          [id]="currentActiveIndex"
          (relationshipListEmitter)="handlerRelationshipList($event)"
          [relationshipType]="steps[currentActiveIndex].relationshipType"
          [currentType]="steps[currentActiveIndex]"
          (moveToNextStepEmitter)="handleMoveToNextStep()"
        ></setup-controller>
        } } } @else if(currentActiveIndex === steps.length - 1 ){
        <div class="mr-[42px]">
          <div class="rounded-xl min-h-60 w-full border bg-white flex items-center justify-center flex-col py-8 px-12 mt-4">
            <p
              [class]="
                screenWidth > 480
                  ? 'sm:mb-2 text-xl text-center  text-[#53565B] font-semibold'
                  : 'sm:mb-[8px] text-xl leading-5 text-center text-[#53565B] font-semibold'
              "
            >
              Mark
              <span class="font-weight-bold-blue"> {{ (currentUser.nick_name ?? currentUser.first_name) + "'s" | titlecase }} Network </span>
              as Complete?
            </p>
            <p class="text-[#18191C] text-sm text-center mb-[42px]">
              You can add, edit, or remove connections at any point in the future from the network section of this account.
            </p>
            <div class="flex mt-1">
              <app-button-slide (isSubmitButtonActiveForSubMit)="submitAllFormAnswers($event)" [customTextSize]="true"></app-button-slide>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="relative w-full flex flex-col pr-[42px]">
        <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
        <div
          class="edit__profile-footer-transparent pt-0 items-center px-10"
          [ngClass]="{
            'justify-between': currentActiveIndex > 0,
            'justify-end': currentActiveIndex > 0 && relationshipList().length > 0 && currentActiveIndex !== steps.length - 1,
            'justify-start': currentActiveIndex === steps.length - 1
          }"
        >
          @if ((currentActiveIndex > 0) || currentActiveIndex === steps.length -1 ) {
          <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="gotoPrevious()">
            <span class="flex items-center gap-2 text-[#18191C]"
              ><span class="material-icons text-base"> arrow_back</span>
              <span class="text-sm font-semibold"> Back </span>
            </span>
          </button>
          } @if (currentActiveIndex < steps.length - 1) {
          <button
            style="height: 48px; margin-bottom: 12px"
            class="app__btn--primary w-fit min-w-[158px] py-3 px-8 mt-5"
            (click)="
              currentActiveIndex === steps.length - 1 && markAsComplete
                ? completeSetup()
                : currentActiveIndex === steps.length - 1 && !markAsComplete
                ? closeSideNav()
                : handleSidenavMenuNavigation()
            "
          >
            Continue
          </button>
          }
        </div>
      </div>
    </div>

    @if (showLoader) {
    <div>
      <div class="loading-spinner loader-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    }
  </div>
</section>
